// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//中英文切换
import VueI18n from 'vue-i18n'
// import * as  vueJsonp from 'vue-jsonp'
// import BaiduMap from 'vue-baidu-map'
Vue.use(VueI18n)
// Vue.use(vueJsonp)

const i18n=new VueI18n({
    locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
    messages:{
      'zh':require('./components/language/zh'),
      'en':require('./components/language/en')
    }
})

// Vue.use(BaiduMap, {
//   /* 申请的百度密钥，可以在百度地图官网申请 */
//   ak: 'psDzDDFtF0WIG8od3Xks3qMPer2rFRzS'
// })
Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   // chrome
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0
//   next()
// });
/* eslint-disable no-new */
window.$vrm = new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js